<template>
  <div>
    <a-form-model
      ref="rechargeFormTwo"
      :model="rechargeForm2"
      :rules="rechargeForm2Rules"
      style="margin: 40px auto 0;"
    >
      <a-alert
        :closable="true"
        message="确认订单信息，订单生成并支付成功将无法取消！！！"
        style="margin-bottom: 24px;"
      />
      <a-form-model-item
        label="商品"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        style="margin-bottom: 0"
      >
        {{ order.goodsName }}
      </a-form-model-item>
      <a-form-model-item
        label="价格"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        style="margin-bottom: 0"
      >
        <template v-if="order.deviceType === 1">
          {{ order.price / 100 }} 元
        </template>
        <template v-else>
          {{ order.price / 100 }} 元 / 设备
        </template>
      </a-form-model-item>
      <a-form-model-item
        label="购买数量"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        style="margin-bottom: 0"
      >
        {{ order.amountPerDevice }}
      </a-form-model-item>
      <template v-if="order.deviceType !== 1">
        <a-form-model-item
          v-if="order.deviceType !== 1"
          label="设备数量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          style="margin-bottom: 0"
        >
          {{ order.devices.length }} 台
        </a-form-model-item>
        <a-form-model-item
          label="设备列表"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-table
            class="table-area"
            style="min-height: 100px;max-height: 400px"
            :columns="columns"
            :dataSource="order.devices"
          >
            <template slot="deviceTypeCode" slot-scope="text, record">
              {{deviceTypes[text] ? deviceTypes[text]['title'] : ''}}
            </template>
          </a-table>
        </a-form-model-item>
        <a-divider />
        <a-form-model-item
          label="总金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <p style="margin-bottom: 0">{{ order.price * order.amountPerDevice * order.deviceIds.length / 100 }} 元</p>
          <p style="margin-bottom: 0">计费规则： 商品价格 ∗ 商品购买数量 ∗ 设备数量</p>
        </a-form-model-item>
      </template>
      <template v-else>
        <a-form-model-item
          label="总金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <p style="margin-bottom: 0">{{ order.price / 100 * order.amountPerDevice }} 元</p>
          <p style="margin-bottom: 0">计费规则： 商品价格 ∗ 商品购买数量 </p>
        </a-form-model-item>
      </template>

      <a-form-model-item
        label="支付方式"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        prop="payType"
      >
        <a-radio-group
          v-model="rechargeForm2.payType"
          button-style="solid"
        >
          <a-radio-button v-for="type in payTypes" :key="type.code" :icon="type.icon" :value="type.code">{{ type.name }}</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-item :wrapperCol="{span: 19, offset: 5}">
        <a-button @click="prevStep">上一步</a-button>
        <a-button style="margin-left: 8px" :loading="loading" type="primary" @click="nextStep">提交</a-button>
      </a-form-item>
    </a-form-model>
  </div>
</template>

<script>

import { CreateDeviceOrder, createUserOrder } from '../../../../api/recharge'

const rechargeForm2Rules = { payType: [{ required: true, message: '请选择支付方式！' }],}
import store from '@/store'

const enumsData = store.state.enumsStore.enumsData
const deviceTypes = enumsData.deviceType.reduce((deviceTypes, item) => {
  deviceTypes[item.key] = item;
  return deviceTypes;
}, {});


import columns from './tableConfig'
const payTypes = [
  {code: 1, name: '微信', icon: 'wechat-outline'},
  {code: 2, name: '支付宝', icon: 'alipay-outlined'}
]

export default {
  name: 'Step2',
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      columns,
      payTypes,
      deviceTypes,
      rechargeForm2: this.order,
      rechargeForm2Rules,
      labelCol: { lg: { span: 5 }, sm: { span: 5 } },
      wrapperCol: { lg: { span: 19 }, sm: { span: 19 } },
      form: this.$form.createForm(this),
      loading: false,
    }
  },
  methods: {
    nextStep () {
      let _this = this
      this.$refs.rechargeFormTwo.validate(async valid => {
        if (valid) {
          const { amountPerDevice, deviceIds, goodId, payType, deviceType } = this.rechargeForm2
            try {
              _this.loading = true
              if (deviceType === 1){
                await createUserOrder({
                  amount:amountPerDevice,
                  goodId,
                  payType
                }).then(res=>{
                  let payInfo = res.data.collection[0]
                  console.log(payInfo)
                  if ( payInfo && payInfo.qrCode && payInfo.id){
                    _this.rechargeForm2 = Object.assign(_this.rechargeForm2, payInfo)
                    _this.loading = false
                  }else{
                    throw new Error("获取订单支付信息失败")
                  }
                  _this.$emit('nextStep', this.rechargeForm2)
                })
              }else{
                await CreateDeviceOrder({
                  amountPerDevice, deviceIds, goodId, payType
                }).then(res=>{
                  let payInfo = res.data.collection[0]
                  console.log(payInfo)
                  if ( payInfo && payInfo.qrCode && payInfo.id){
                    _this.rechargeForm2 = Object.assign(_this.rechargeForm2, payInfo)
                    _this.loading = false
                  }else{
                    throw new Error("获取订单支付信息失败")
                  }
                  _this.$emit('nextStep', this.rechargeForm2)
                })
              }

            }catch (err) {
              _this.loading = false
              _this.$message.error('订单创建失败！！！');
            }

        }
      })
    },
    prevStep () {
      this.$emit('prevStep')
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
